// Importing the required types for login details and user registration data
import { ILoginDetails } from "../../../features/login/types";
import { IMisCreateUserData } from "../../../Types/Auth";
import ApiService from "../../ApiService";

enum AuthEndpoints {
  LOGIN = "/login",
  REGISTER = "/register",
}

// Defining the AuthService class which extends the base ApiService class
class AuthService extends ApiService {
  // Function to handle the login process
  async login(email: string, password: string): Promise<ILoginDetails> {
    const payload = {
      email,
      password,
    };
    return this.post<ILoginDetails>(AuthEndpoints.LOGIN, payload);
  }

  // Function to handle user registration
  async register(registerData: IMisCreateUserData): Promise<any> {
    return this.post(AuthEndpoints.REGISTER, registerData);
  }
}

// Creating an instance of AuthService and exporting it for use in other parts of the application
export const authService = new AuthService();
